import { CONTROL_NAME } from '@epilot/journey-logic-commons'
import { useEffect, useState } from 'react'

import type { AnimationType } from '../../../concorde-renderers/layouts/components'

export type AnimationOptions = {
  animationType: AnimationType
  isAnimationActive: boolean
  shouldReduceMotion: boolean | null
}

export const NOT_REVEALED_CONTROLS = [CONTROL_NAME.CONFIRMATION_MESSAGE_CONTROL]

export const POSITION_LAYOUT_ANIMATION_BLOCK_TYPES = [
  CONTROL_NAME.PRODUCT_SELECTION_CONTROL,
  CONTROL_NAME.JOURNEY_LAUNCHER_CONTROL,
  CONTROL_NAME.DATE_PICKER
]

export function useAnimationEffect() {
  const [animationType, setAnimationType] = useState<AnimationType>('load')

  useEffect(() => {
    setAnimationType('visibility')
  }, [])

  return {
    animationType
  }
}
